import { render, staticRenderFns } from "./PlayerStats.vue?vue&type=template&id=6e054be6&lang=pug"
import script from "./PlayerStats.vue?vue&type=script&lang=js"
export * from "./PlayerStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports